// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import queryString from "query-string"
import style from "./style.css"
import Dropdown from "react-toolbox/lib/dropdown"
import Input from "react-toolbox/lib/input"
import FontIcon from "react-toolbox/lib/font_icon"
import Dialog from "react-toolbox/lib/dialog"
import AlertBox from "../../components/CreatePaymentAgreementComponents/AlertBox"
import CreateInvoice from "../../components/CreatePaymentAgreementComponents/CreateInvoice"
import Division from "../../components/Division"
import Avatar from "react-toolbox/lib/avatar/Avatar"
import Chip from "react-toolbox/lib/chip/Chip"
import SaveButton from "../../components/SaveButton"
import PaymentsTracking from "./PaymentsTracking"
import _ from "lodash"
import { connect } from "react-redux"
import { formatDate, getCurrentInterestTax, formatDateToShortDate, translationFunction } from "../../utils"
import * as paymentCalculation from "../../paymentAgreementCalculation"
import Hidable from "../../components/Hidable"
import DatePicker from "../../components/DatePicker"
import { toastr } from "react-redux-toastr"
import download from "downloadjs"

import * as strings from "../../strings"
import {
  getPaymentAgreementById,
  updatePaymentAgreement,
  getAllInterestTypes,
  unparsedTokenCommand,
  removePaymentAgreement,
} from "../../actions"

const INPUT_STEP = "0.01"
const MAX_NUMBER_OF_PAYMENTS = 720

class PaymentAgreement extends Component {
  constructor ( props ) {
    super( props )
    this.state = {
      show: false,
      paymentAgreementState: "A Cumprir",
      paymentState: "Acordo recebido",
      showPaymentAgreement: true,
      showInvoices: true,
      invoices: [],
      newInvoices: [],
      debtValue: 0,
      capitalValue: 0,
      paymentAgreementStatus: undefined,
      interestType: [],
      interestValue: 0,
      interestRate: 0,
      justiceTax: 0,
      totalChargedValue: 0,
      valuePerPayment: undefined,
      numberOfPayments: undefined,
      firstPaymentDate: new Date(),
      celebrationDate: undefined,
      plannedPayments: [],
      isChangedPayment: [],
      isByPayments: true,
      newInvoice: {},
      active: false,
      areInputFieldsValid: [ false, false, false ],
      isEdit: undefined,
      isInvalid: [ false, false, false, false, false ],
      payments: [],
      isDisabled: [ false, false, false, false, false, false, false ],
      isLoading: false,
      removeConfirmDialog: false,
      debtor: {},
    }

    this.handleSelect = this.handleSelect.bind( this )
  }

  props: {
    getPaymentAgreementById: any,
    paymentAgreementById: any,
    updatePaymentAgreement: any,
    auth: {
      token: string,
    },
    interestTypes: mixed[],
    getAllInterestTypes: () => any,
    history: any,
    match: {
      path: string,
      params: {
        paymentAgreementId: string,
      },
    },
  }

  fetchNecessaryData = () => {
    if ( this.props.interestTypes.length === 0 ) {
      this.props.getAllInterestTypes()
    }
  }

  componentDidMount = () => {
    window.scrollTo( 0, 0 )
  }

  currentInterestRateValue = ( interestType ) => {
    // TODO: ANYTHING THAT USES THIS FUNCTION IS WRONG!:
    // Calculations should take into account all the possible rates and not just the current one

    const currentInterestRate = ( ( interestType && interestType.interestTypeRates ) || [] ).find( rate => {
      const now = new Date()
      return new Date( rate.startDate ) >= now && now <= new Date( rate.endDate )
    } )
    const result = parseFloat( currentInterestRate && currentInterestRate.value )
    return isNaN( result ) ? 0 : result
  }

  componentWillMount () {
    this.fetchNecessaryData()
    let paymentAgreementId = parseInt( this.props.match.params.paymentAgreementId, 10 )
    this.props.getPaymentAgreementById( paymentAgreementId ).then( () => {
      return this.setState( {
        ...this.prepareState(),
      } ) } )
  }

  prepareState = () => {
    const { paymentAgreementById } = this.props
    const interestTypeId = paymentAgreementById.idInterestType || 0
    const interestType = this.props.interestTypes.find( interestType => interestType.id === interestTypeId )
    const currentInterestRateValue = interestType && interestType.interestTypeRates.length !== 0 ?
      getCurrentInterestTax( interestType.interestTypeRates ).value : 0

    let invoiceExpiryDates = {}
    let invoiceValues = {}
    paymentAgreementById.invoices.map( invoice => {
      invoiceExpiryDates[ invoice.id ] = new Date( invoice.expiryDate )
      invoiceValues[ invoice.id ] = parseFloat( invoice.value )
    } )

    const firstPaymentDate = _.get(paymentAgreementById, "plannedPayments[0].expiryDate");

    return {
      ...this.state,
      celebrationDate: paymentAgreementById.effectiveDate !== null ? new Date( paymentAgreementById.effectiveDate ) : null,
      debtValue: parseFloat( paymentAgreementById.debtValue ),
      capitalValue: parseFloat( paymentAgreementById.capitalValue ),
      firstPaymentDate: firstPaymentDate && new Date( firstPaymentDate ),
      invoices: paymentAgreementById.invoices,
      totalChargedValue: parseFloat( paymentAgreementById.totalChargedValue ),
      numberOfPayments: parseFloat( paymentAgreementById.plannedPayments.length ),
      valuePerPayment: parseFloat( this.getMaxValue( paymentAgreementById.plannedPayments ) ),
      plannedPayments: paymentAgreementById.plannedPayments,
      justiceTax: parseFloat( paymentAgreementById.justiceTax ),
      idInterestType: paymentAgreementById.idInterestType,
      interestRate: currentInterestRateValue,
      interestValue: parseFloat( paymentAgreementById.interestValue ),
      payments: paymentAgreementById.payments,
      ...this.checkDisabledFields( paymentAgreementById.status ),
    }

  }

  componentWillReceiveProps = ( nextProps ) => {
    const { paymentAgreementById } = nextProps
    if ( !paymentAgreementById ) {
      return
    }

    const interestTypeId = nextProps.paymentAgreementById.idInterestType || 0
    const interestType = nextProps.interestTypes.find( interestType => interestType.id === interestTypeId )
    const currentInterestRateValue = interestType && interestType.interestTypeRates.length !== 0 ?
      getCurrentInterestTax( interestType.interestTypeRates ).value : 0

    let invoiceExpiryDates = {}
    let invoiceValues = {}
    paymentAgreementById.invoices.map( invoice => {
      invoiceExpiryDates[ invoice.id ] = new Date( invoice.expiryDate )
      invoiceValues[ invoice.id ] = parseFloat( invoice.value )
    } )

    const firstPaymentDate = _.get(paymentAgreementById, "plannedPayments[0].expiryDate");

    this.setState( {
      ...this.state,
      debtValue: parseFloat( paymentAgreementById.debtValue ),
      capitalValue: parseFloat( paymentAgreementById.capitalValue ),
      firstPaymentDate: firstPaymentDate && new Date( firstPaymentDate ),
      invoices: paymentAgreementById.invoices,
      totalChargedValue: parseFloat( paymentAgreementById.totalChargedValue ),
      numberOfPayments: parseFloat( paymentAgreementById.plannedPayments.length ),
      valuePerPayment: parseFloat( this.getMaxValue( paymentAgreementById.plannedPayments ) ),
      plannedPayments: paymentAgreementById.plannedPayments,
      justiceTax: parseFloat( paymentAgreementById.justiceTax ),
      paymentAgreementStatus: paymentAgreementById.status,
      idInterestType: paymentAgreementById.idInterestType,
      interestRate: currentInterestRateValue,
      interestValue: parseFloat( paymentAgreementById.interestValue ),
      isEdit: paymentAgreementById.status === "Draft",
    } )
  }

  formatPlannedPayments = ( plannedPayments ) => {
    return plannedPayments.map( plannedPayment => {
      const expiryDate = new Date( plannedPayment.expiryDate )
      return {
        expiryDate,
        paymentStatus: plannedPayment.paymentStatus,
        value: plannedPayment.value ? plannedPayment.value.toString() : undefined,
      } } )
  }

  formatPayments = ( payments ) => {
    return payments.map( payment => ( {
      value: parseFloat( payment.value ).toFixed( 2 ),
    } ) )
  }

  checkChanges = () => {
    const state = this.state
    const { paymentAgreementById } = this.props

    if ( !state ) {
      return false
    }


    const requestPlannedPayments = this.formatPlannedPayments( paymentAgreementById.plannedPayments )
    const statePlannedPayments = this.formatPlannedPayments( state.plannedPayments )

    const effectiveDate = formatDate( state.celebrationDate ) !==
    formatDate( paymentAgreementById.effectiveDate )
    const debtValue = state.debtValue !== parseFloat( paymentAgreementById.debtValue )
    const numberOfPayments = state.numberOfPayments !== parseFloat( paymentAgreementById.plannedPayments.length )
    const firstPaymentDate = formatDate( state.firstPaymentDate ) !== formatDate( _.get(paymentAgreementById, "plannedPayments[0].expiryDate" ))
    const capitalValue = state.capitalValue !== parseFloat( paymentAgreementById.capitalValue )
    const valuePerPayment = state.valuePerPayment !== parseFloat( this.getMaxValue( this.props.paymentAgreementById.plannedPayments ) )
    const justiceTax = state.justiceTax !== parseFloat( paymentAgreementById.justiceTax )
    const interestValue = parseFloat( state.interestValue ) !== parseFloat( paymentAgreementById.interestValue )
    const paymentAgreementStatus = state.paymentAgreementStatus !== paymentAgreementById.status
    const invoices = state.invoices !== paymentAgreementById.invoices
    const plannedPayments = !_.isEqual( requestPlannedPayments, statePlannedPayments )

    const show = effectiveDate || debtValue || numberOfPayments || firstPaymentDate ||
      capitalValue || valuePerPayment || justiceTax || paymentAgreementStatus || invoices || plannedPayments || interestValue

    return show
  }

  setUpPaymentAgreement = () => {
    const state = this.state
    const invoiceIds = state.invoices.map( invoice => invoice.id )

    const plannedPayments = state.plannedPayments.map( plannedPayment => ( {
      value: ( typeof plannedPayment.value ) === "number" ? plannedPayment.value.toFixed( 2 ) : plannedPayment.value,
      expiryDate: formatDateToShortDate( plannedPayment.expiryDate ),
      paymentStatus: plannedPayment.paymentStatus,
    } ) )
    const newInvoices = state.newInvoices.map( newInvoice => ( {
      ...newInvoice,
      value: newInvoice.value.toFixed( 2 ),
    } ) )
    return {
      capitalValue: state.capitalValue !== undefined ? state.capitalValue.toString() : undefined,
      interestValue: state.interestValue !== undefined ? state.interestValue.toString() : undefined,
      justiceTax: state.justiceTax !== undefined ? state.justiceTax.toString() : undefined,
      status: state.paymentAgreementStatus,
      existentInvoices: invoiceIds,
      invoices: newInvoices,
      plannedPayments,
      idContact: this.props.paymentAgreementById.idContact,
      id: this.props.paymentAgreementById.id,
      effectiveDate: state.celebrationDate ? formatDateToShortDate( state.celebrationDate ) : null,
    }
  }

  isInvalidInput = ( value ) => {
    return parseFloat( value ) < 0 || value === "" || value === undefined || isNaN( value ) ? strings.errorMessages.invalidField : false
  }

  updatePaymentAgreement = () => {
    const updatedPaymentAgreement = this.setUpPaymentAgreement()
    const payments = this.state.paymentAgreementStatus === "Draft" ? [] : this.state.payments
    if ( !this.isInvalidInput( this.state.valuePerPayment ) &&
      !this.isInvalidInput( this.state.numberOfPayments ) && !this.isInvalidInput( this.state.justiceTax ) &&
        !this.isInvalidInput( this.state.interestValue ) && !this.isInvalidInput( this.state.capitalValue ) ) {
      this.props.updatePaymentAgreement( updatedPaymentAgreement )
        .then( () => toastr.success( strings.generalStrings.changesSaved ) )
        .catch( () => toastr.error( strings.generalStrings.errorSaving ) )
    }

    this.setState( {
      isInvalid: [ this.isInvalidInput( this.state.valuePerPayment ),
        this.isInvalidInput( this.state.numberOfPayments ), this.isInvalidInput( this.state.justiceTax ),
        this.isInvalidInput( this.state.interestValue ), this.isInvalidInput( this.state.capitalValue ) ],
      payments,
    } )

    this.setState({debtor: this.props.paymentAgreementById.debtor})
  }

  resetPaymentAgreement = () => {
    return this.setState( {
      ...this.prepareState(),
    } )
  }


  handleSelect = ( event ) => {
    this.setState( {
      paymentAgreementState: event.target.value,
    } )
  }

  handleSelect2 = ( event ) => {
    this.setState( {
      paymentState: event.target.value,
    } )
  }

  checkContactField = ( field ) => {
    const { generalStrings } = strings
    
    const { debtor } = this.props.paymentAgreementById.debtor ? this.props.paymentAgreementById : this.state
    return _.get( debtor, "contact." + field ) || generalStrings.emptyField
  }

  renderClientIsland = () => {
    const { generalStrings } = strings
    return (
      <div className={style.clientIsland}>
        <div className={style.blueBar}/>
        <div>
          <div>
            <Division title={strings.debtor.title.toUpperCase()}/>
            <div className={style.gridDebtor}>
              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.name}</p>
                <p className={style.tableContent}>{this.checkContactField( "name" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{generalStrings.documentType}: {translationFunction( this.checkContactField( "documentType" ) )}</p>
                <p className={style.tableContent}>{this.checkContactField( "documentNumber" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.nif}</p>
                <p className={style.tableContent}>{this.checkContactField( "nif" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.address}</p>
                <p className={style.tableContent}>{this.checkContactField( "address" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.local}</p>
                <p className={style.tableContent}>{this.checkContactField( "city" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.zipCode}</p>
                <p className={style.tableContent}>{this.checkContactField( "zipCode" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.phone}</p>
                <p className={style.tableContent}>{this.checkContactField( "phone" )}</p>
              </div>

              <div className={style.bottomColumn}>
                <p className={style.tableTitle}>{strings.generalStrings.email}</p>
                <p className={style.tableContent}>{this.checkContactField( "email" )}</p>
              </div>
            </div>
          </div>
        </div>
      </div>


    )
  }

  renderInvoices = ( invoices, isDraft, isNewInvoice ) => {
    return invoices.map( ( invoice, i ) =>
      <tr key={i} >
        {isDraft || <td >
          <div className={style.clearFix}>
            <FontIcon onClick={() => this.deleteInvoice( invoices, invoice, isNewInvoice )}>clear</FontIcon>
          </div>
        </td>}
        <td>{invoice.documentNumber}</td>
        <td>{invoice.value}</td>
        <td>{formatDate( invoice.date )}</td>
        <td>{formatDate( invoice.expiryDate )}</td>
      </tr>
    )
  }

  renderInvoicesIsland = () => {
    const { isEdit } = this.state
    return (
      <div className={this.state.showInvoices ? style.invoicesIsland : style.hiddenContent}>
        <div className={style.betweenDivisors}>
          <table className={style.tableCss}>
            <thead>
              <tr className={style.borderBottom}>
                {!isEdit || <td className={style.clearFix}/>}
                <td className={style.tdTitle}>{strings.paymentAgreements.documentNumber}</td>
                <td className={style.tdTitle}>{strings.generalStrings.value}</td>
                <td className={style.tdTitle}>{strings.generalStrings.emissionDate}</td>
                <td className={style.tdTitle}>{strings.generalStrings.expiryDate}</td>
              </tr>
            </thead>
            <tbody>
              {this.renderInvoices( this.state.invoices, !isEdit, false )}
              {this.renderInvoices( this.state.newInvoices, !isEdit, true )}
            </tbody>
          </table>
          {!isEdit || <div onClick={this.handleToggle} className={style.divButtonSubmit}> {strings.invoices.addInvoice} </div>}
          <Dialog
            actions={ [
              { label: strings.generalStrings.cancel, onClick: this.handleToggle },
              { label: strings.generalStrings.submit, onClick: () => this.handleSubmit() },
            ]}
            className={style.dialogBoxFormat}
            active={this.state.active}
            onEscKeyDown={this.handleToggle}
            onOverlayClick={this.handleToggle}>
            <CreateInvoice
              areInputFieldsValid={this.state.areInputFieldsValid}
              newInvoice={this.state.newInvoice}
              onChange={this.handleChange}
            />
          </Dialog>
        </div>
      </div>
    )
  }

  calculateTotalDebt = ( newInvoice ) => {
    let invoices = this.state.newInvoices
    invoices.push( newInvoice )
    const debtValue = _.sum ( invoices.map( invoice => parseFloat( invoice.value ) ) )
    return debtValue
  }

  handleSubmit = () => {
    const { newInvoice } = this.state
    const errorMessage = <span> {strings.generalStrings.missingField} </span>

    let validInputs = [ newInvoice.documentNumber ? false : errorMessage,
      newInvoice.value ? false : errorMessage, newInvoice.expiryDate ? false : errorMessage ]

    let newInvoices = this.state.newInvoices
    if ( newInvoice.documentNumber && newInvoice.value && newInvoice.date && newInvoice.expiryDate ) {

      let total = this.calculateTotalDebt( newInvoice )
      this.setState( {
        newInvoices: newInvoices,
        debtValue: _.round( total, 2 ),
        capitalValue: _.round( total, 2 ),
        justiceTax: undefined,
        numberOfPayments: undefined,
        valuePerPayment: undefined,
        interestValue: 0,
        interestRate: 0,
        plannedPayments: [],
      } )
      this.setState( { active: !this.state.active } )
    }
    this.setState( {
      areInputFieldsValid: validInputs,
    } )
  }

  handleToggle = () => {
    this.setState( {
      active: !this.state.active,
      newInvoice: {
        documentNumber: undefined,
        value: undefined,
        date: new Date(),
        expiryDate: undefined,
      },
      areInputFieldsValid: [ false, false, false ],
    } )
  }

  handleChange = ( event ) => {
    return this.setState( {
      newInvoice: {
        ...this.state.newInvoice,
        ...event,
      },
    } )
  }

  deleteInvoice = ( invoices, invoice, isNewInvoice ) => {
    let newInvoices = invoices
    const invoiceWithout = _.without( newInvoices, invoice )
    const newDebtValue = _.sum( invoiceWithout.map( invoice => parseFloat( invoice.value ) ) )
    const objectToReturn = isNewInvoice ? { newInvoices: invoiceWithout } : { invoices: invoiceWithout }

    return this.setState( {
      ...objectToReturn,
      debtValue: newDebtValue,
      capitalValue: newDebtValue,
      numberOfPayments: undefined,
      valuePerPayment: undefined,
      justiceTax: undefined,
      plannedPayments: [],
    } )
  }

  getJusticeOrInterestValues = ( isJusticeTax ) => {
    const state = this.state

    const valueToAdd = isJusticeTax ? state.justiceTax || 0 : state.interestValue || 0
    const interestValuePlusJusticeTax = isJusticeTax ?
      ( state.interestValue ? state.interestValue : 0 ) + valueToAdd :
      ( state.justiceTax ? state.justiceTax : 0 ) + valueToAdd

    let newDebtValue = _.round( ( state.capitalValue + interestValuePlusJusticeTax ), 2 )

    return {
      ...paymentCalculation.handleChangedDebt( newDebtValue,
        state.justiceTax, state.interestValue,
        state.numberOfPayments, state.capitalValue,
        state.valuePerPayment, state.firstPaymentDate,
        state.isByPayments ),
    }
  }

  justiceOrInterestFunction = ( isJusticeTax ) => {
    let returnedValues = this.getJusticeOrInterestValues( isJusticeTax )
    let newPlannedPayments = this.formatNewPlannedPayments( returnedValues )

    return {
      numberOfPayments: returnedValues.numberOfPayments,
      valuePerPayment: returnedValues.valuePerPayment,
      plannedPayments: newPlannedPayments,
      debtValue: returnedValues.debtValue,
    }
  }

  getMaxValue = ( plannedPayments ) => {
    const plannedPaymentValues = plannedPayments.map( plannedPayment =>
      parseFloat( plannedPayment.value )
    )
    return _.max( plannedPaymentValues )
  }


  formatNewPlannedPayments = ( plannedPayments ) => {
    return plannedPayments.payments.map( ( payment, i ) => {
      return {
        value: payment,
        expiryDate: plannedPayments.paymentDates[ i ],
        paymentStatus: "Waiting",
        isChangedPayment: false,
      }
    } )
  }

  capitalValueFunction = () => {
    const state = this.state
    let capitalValue = state.capitalValue
    if ( !capitalValue ) {
      capitalValue = _.round( _.sum( state.invoices.map( invoice => parseFloat( invoice.value ) ) ), 2 )
    }
    let returnedValues = paymentCalculation.handleChangedCapitalValue( state.debtValue,
      state.justiceTax, state.interestValue, state.numberOfPayments, capitalValue,
      state.valuePerPayment, state.firstPaymentDate, state.isByPayments )

    let newPlannedPayments = this.formatNewPlannedPayments( returnedValues )

    return {
      numberOfPayments: returnedValues.numberOfPayments,
      valuePerPayment: returnedValues.valuePerPayment,
      plannedPayments: newPlannedPayments,
      debtValue: returnedValues.debtValue,
    }
  }

  agreedValueFunction = () => {
    const state = this.state
    let returnedValues = paymentCalculation.handleChangedDebt( state.debtValue,
      state.justiceTax, state.interestValue, state.numberOfPayments, state.capitalValue,
      state.valuePerPayment, state.firstPaymentDate, state.isByPayments )

    let newPlannedPayments = this.formatNewPlannedPayments( returnedValues )

    return {
      numberOfPayments: returnedValues.numberOfPayments,
      valuePerPayment: returnedValues.valuePerPayment,
      plannedPayments: newPlannedPayments,
      debtValue: returnedValues.debtValue,
    }
  }

  valuePerPaymentFunction = () => {
    const state = this.state
    let returnedPayments = paymentCalculation.handlePaymentByValue( state.valuePerPayment,
      state.debtValue, state.firstPaymentDate )

    let newPlannedPayments = this.formatNewPlannedPayments( returnedPayments )

    return {
      plannedPayments: newPlannedPayments,
      isByPayments: returnedPayments.isByPayments,
      numberOfPayments: returnedPayments.numberOfPayments,
    }
  }

  numberOfPaymentsFunction = () => {
    const state = this.state
    if ( state.numberOfPayments <= MAX_NUMBER_OF_PAYMENTS ) {
      let returnedPayments = paymentCalculation.handlePayments( state.numberOfPayments,
        state.debtValue, state.firstPaymentDate )

      let newPlannedPayments = this.formatNewPlannedPayments( returnedPayments )

      return {
        plannedPayments: newPlannedPayments,
        isByPayments: returnedPayments.isByPayments,
        valuePerPayment: returnedPayments.valuePerPayment,
      }
    } else {
      return undefined
    }
  }

  renderPaymentAgreementIsland = () => {
    const { paymentAgreementById } = this.props
    const { isDisabled } = this.state
    const state = this.state
    if ( !paymentAgreementById ) {
      return null
    }

    return (
      <div className={this.state.showPaymentAgreement ? style.showContent : style.hiddenContent}>
        <div className={style.paymentAgreementInfo}>
          <div className={style.wrapper}>
            <div className={style.two}>
              <p className={style.disabledInputTitle}>{strings.paymentAgreements.debtValue}</p>
              <p className={style.disabledInputValue}>{_.round( state.debtValue -
                  state.totalChargedValue, 2 ) + strings.generalStrings.currency}</p>
            </div>
            <div className={style.three}>
              <p className={style.disabledInputTitle}>{strings.paymentAgreements.chargedValue}</p>
              <p className={style.disabledInputValue}>{( _.round( state.totalChargedValue, 2 ) || 0 ) + strings.generalStrings.currency}</p>
            </div>
            <div className={style.four}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.setState( {
                  ...this.capitalValueFunction(),
                } )
              } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  disabled={!this.state.isEdit}
                  label={strings.paymentAgreements.capitalValue}
                  value={_.round( state.capitalValue, 2 )}
                  onChange={( event ) =>
                    this.setState( {
                      capitalValue: event !== "" ? parseFloat( event ) : undefined,
                    } )}
                  onBlur={ () => {
                    return this.setState( {
                      ...this.capitalValueFunction(),
                    } ) } }
                  error={this.state.isInvalid[ 4 ]}
                  type="number" min="0" step={INPUT_STEP}/>
              </form>
            </div>
            <div className={style.five}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.setState( {
                  ...this.agreedValueFunction(),
                } )
              } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  disabled={!this.state.isEdit}
                  label={strings.paymentAgreements.agreedValue}
                  value={_.round( state.debtValue, 2 )}
                  onChange={( event ) =>
                    this.setState( {
                      debtValue: event !== "" ? parseFloat( event ) : undefined,
                    } )}
                  onBlur={ () => {
                    return this.setState( {
                      ...this.agreedValueFunction(),
                    } ) } }
                  type="number" min="0" step={INPUT_STEP}/>
              </form>
            </div>
            <form onSubmit={ ( e ) => {
              e.preventDefault()
              return this.setState( {
                ...this.justiceOrInterestFunction( false ),
              } )
            } }>
              <Input
                className={style.inputFieldsPrefix}
                icon={"euro_symbol"}
                disabled={!this.state.isEdit}
                label={strings.paymentAgreements.interestValue}
                value={_.round( state.interestValue, 2 )}
                onChange={( event ) =>
                  this.setState( {
                    interestValue: event !== "" ? parseFloat( event ) : undefined,
                  } )}
                error={this.state.isInvalid[ 3 ]}
                onBlur={ () => {
                  return this.setState( {
                    ...this.justiceOrInterestFunction( false ),
                  } ) } }
                type="number" min="0" step={INPUT_STEP}/>
            </form>
            <div className={style.seven}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.setState( {
                  ...this.valuePerPaymentFunction(),
                } )
              } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  disabled={!this.state.isEdit}
                  label={strings.paymentAgreements.valuePerPayment}
                  value={state.valuePerPayment || "" }
                  type="number" min="0" step={INPUT_STEP}
                  onChange={ value => this.setState( {
                    valuePerPayment: value !== "" ? parseFloat( value ) : undefined,
                  } ) }
                  error={this.state.isInvalid[ 0 ]}
                  onBlur={ () => {
                    return this.setState( {
                      ...this.valuePerPaymentFunction(),
                    } )
                  }}/>
              </form>
            </div>
            <div className={style.eight}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.setState( {
                  ...this.numberOfPaymentsFunction(),
                } )
              } }>
                <Input
                  disabled={!this.state.isEdit}
                  label={strings.paymentAgreements.numberOfPayments}
                  value={state.numberOfPayments || ""}
                  type="number" min="0" step={INPUT_STEP}
                  error={( state.numberOfPayments || 0 ) > MAX_NUMBER_OF_PAYMENTS ? "Número máximo de prestações: " + MAX_NUMBER_OF_PAYMENTS : this.state.isInvalid[ 1 ]}
                  onChange={ value => this.setState( {
                    numberOfPayments: value !== "" ? parseFloat( value ) : undefined,
                  } )}
                  onBlur={ () => {
                    return this.setState( {
                      ...this.numberOfPaymentsFunction(),
                    } )
                  }
                  }/>
              </form>
            </div>
            <div className={style.nine}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.setState( {
                  ...this.justiceOrInterestFunction( true ),
                } )
              } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  disabled={!this.state.isEdit}
                  label={strings.paymentAgreements.justiceTax}
                  value={state.justiceTax === undefined ? "" : state.justiceTax}
                  onChange={ value => this.setState( {
                    justiceTax: value !== "" ? parseFloat( value ) : undefined,
                  } ) }
                  error={this.state.isInvalid[ 2 ]}
                  onBlur={ () => this.setState( {
                    ...this.justiceOrInterestFunction( true ),
                  } ) }
                  type="number" min="0" step={INPUT_STEP}/>
              </form>
            </div>
            <div className={style.ten}>
              <div className={style.datePickerFieldsPrefix}>
                <DatePicker
                  icon="event"
                  label={strings.paymentAgreements.firstPaymentDate}
                  readonly={!this.state.isEdit}
                  value={ this.state.firstPaymentDate }
                  onChange={ event => {
                    let returnedDates = paymentCalculation.updateDates( state.numberOfPayments, event )
                    const plannedPayments = state.plannedPayments.map( ( plannedPayment, i ) => {
                      return {
                        ...plannedPayment,
                        expiryDate: returnedDates[ i ],
                      }
                    } )
                    return this.setState( {
                      firstPaymentDate: event,
                      plannedPayments,
                    } ) }}
                />
              </div>
            </div>
            <div className={style.eleven}>
              <div className={style.datePickerFieldsPrefix}>
                <DatePicker
                  icon={"event"}
                  locale={strings.generalStrings.languageTag}
                  readonly={this.state.isEdit}
                  label={strings.paymentAgreements.celebrationDate}
                  value={this.state.celebrationDate}
                  onChange={ event => {
                    return this.setState( {
                      celebrationDate: event,
                    } ) }
                  }
                />
              </div>
            </div>
            <div className={style.twelve}>
              <Dropdown
                auto={false}
                label="Situação de Cumprimento"
                source={[
                  { value: "Draft", label: "Rascunho" },
                  { value: "WaitingForClientsReply", label: "Aguarda resposta do cliente" },
                  { value: "WaitingForDebtorsReply", label: "Aguarda resposta Devedor" },
                  { value: "WaitingForClientsDebtorReply", label: "Aguarda resposta Cliente/Devedor" },
                  { value: "Sent", label: "Enviado" },
                  { value: "Confirmed", label: "Confirmado" },
                  { value: "Active", label: "Ativo" },
                  { value: "WaitingForTotalPayment", label: "Aguarda pagamento integral" },
                  { value: "Frustrated", label: "Frustrado" },
                  { value: "FinishedSuccessfully", label: "Cumprido" },
                  { value: "FinishedUnsuccessfully", label: "Incumprido" },
                ]}
                onChange={ value => this.setState( {
                  ...this.checkDisabledFields( value ),
                } )}
                value={this.state.paymentAgreementStatus}
              />
            </div>
          </div>
        </div>
        { state.plannedPayments.length !== 0 && state.numberOfPayments <= MAX_NUMBER_OF_PAYMENTS ?
          <div className={style.paymentAgreementPlan}>
            <Division title="ACORDO DE PAGAMENTO"/>
            <div className={style.paymentsTable}>
              <table className={style.tableCss}>
                <thead>
                  <tr className={style.borderBottom}>
                    <td className={style.tdTitle}>Número de Prestação</td>
                    <td className={style.tdTitle}>Valor</td>
                    <td className={style.tdTitle}>Data de Vencimento</td>
                  </tr>
                </thead>
                <tbody>
                  { _.sortBy( state.plannedPayments, "expiryDate" ).map( ( plannedPayment, i ) => {
                    return <tr key={i} className={style.noPadding}>
                      <td>{i + 1}</td>
                      <td>
                        <form onSubmit={ ( e ) => {
                          e.preventDefault()
                          return this.setState( {
                            ...this.editPaymentFunction( i ),
                          } )
                        } }>
                          <Input
                            icon={"euro_symbol"}
                            className={style.inputBoxFix}
                            disabled={!this.state.isEdit}
                            value={plannedPayment.value}
                            onChange={ event => {
                              const newPlannedPayments = state.plannedPayments.map( ( plannedPayment, j ) => {
                                return i !== j ? { ...plannedPayment } :
                                  {
                                    ...plannedPayment,
                                    value: event !== "" ? parseFloat( event ) : undefined,
                                    isChangedPayment: event !== "",
                                  } } )
                              return this.setState( {
                                plannedPayments: newPlannedPayments,
                              } )
                            } }
                            onBlur={() => {
                              return this.setState( {
                                ...this.editPaymentFunction( i ),
                              } )
                            }}
                            type="number" min="0" step={INPUT_STEP}/>
                        </form>
                      </td>
                      <td>{formatDate( plannedPayment.expiryDate )}</td>
                    </tr>
                  } )}
                </tbody>
              </table>
            </div>
          </div> : <div/> }
      </div>
    )
  }

  editPaymentFunction = ( index ) => {
    const { state } = this
    let paymentValues = []
    let isChangedPayments = []

    state.plannedPayments.forEach( plannedPayment => {
      paymentValues.push( plannedPayment.value !== undefined ?
        parseFloat( plannedPayment.value ) : undefined )
      isChangedPayments.push( plannedPayment.isChangedPayment )
    } )
    let returnedPlannedPayments = paymentCalculation.handleChangedPayments(
      state.plannedPayments[ index ].value, isChangedPayments, paymentValues, state.debtValue )
    let newPlannedPayments = returnedPlannedPayments.payments.map( ( payment, i ) => {
      return {
        value: payment,
        isChangedPayment: returnedPlannedPayments.isChangedPayment[ i ],
        paymentStatus: "Waiting",
        expiryDate: state.plannedPayments[ i ].expiryDate,
      }
    } )
    return {
      plannedPayments: newPlannedPayments,
    }
  }

  checkDisabledFields = ( value ) => {
    const statusTypeArray = [ "Draft", "WaitingForClientsReply", "WaitingForDebtorsReply",
      "WaitingForClientsDebtorReply", "Sent", "Confirmed", "Active", "WaitingForTotalPayment", "Frustrated",
      "FinishedSuccessfully", "FinishedUnsuccessfully" ]
    let index = _.indexOf( statusTypeArray, value )
    let indexOfDisabling = 4
    const fieldState = ( this.state.isDisabled || [] ).map( () => {
      const isFieldDisabled = index > indexOfDisabling ? true : false
      indexOfDisabling++
      return isFieldDisabled
    } )
    return {
      paymentAgreementStatus: value,
      isDisabled: fieldState,
      isEdit: !( index > 4 ),
    }
  }

  updateChargedValue = ( value, plannedPaymentValue ) => {
    let newTotalChargedValue = value === "Paid" ?
      this.state.totalChargedValue + plannedPaymentValue :
      this.state.totalChargedValue - plannedPaymentValue
    return newTotalChargedValue
  }
  showContent = ( stateToChange ) => {
    if ( stateToChange === "showPaymentAgreement" ) {
      this.setState( {
        ...this.state,
        showPaymentAgreement: !this.state.showPaymentAgreement,
      } )
    } else {
      this.setState( {
        ...this.state,
        showInvoices: !this.state.showInvoices,
      } )
    }
  }

  removePaymentAgreement = ( debtId ) => {
    removePaymentAgreement( this.props.auth.token, parseInt( this.props.match.params.paymentAgreementId, 10 ) )
      .then( () => this.props.history.push( "/debt/" + debtId ) )
  }

  renderConfirmationDialog = ( debtId ) => {

    const title = strings.generalStrings.delete + " " + strings.paymentAgreements.paymentAgreementTitle
    const message = strings.generalStrings.confirm + "?"

    return (
      <Dialog
        actions={ [
          { label: strings.generalStrings.cancel, onClick: this.toggleRemoveConfirm },
          { label: strings.generalStrings.confirm, onClick: () => this.removePaymentAgreement( debtId ) },
        ]}
        className={style.dialogBoxFormat}
        active={this.state.removeConfirmDialog}
        onEscKeyDown={this.toggleRemoveConfirm}
        onOverlayClick={this.toggleRemoveConfirm}>
        <AlertBox title={title} message={ message } />
      </Dialog>
    )
  }

  toggleRemoveConfirm = () => {
    this.setState( {
      removeConfirmDialog: !this.state.removeConfirmDialog,
    } )
  }

  renderHeader = () => {
    const parsedURL = queryString.parse( location.search )
    const debtId = parsedURL.debtId
    return (
      <div className={style.paymentAgreementInformation}>
        <div className={style.blueBar}/>
        <div className={style.rightHeader}>
          <div>
            <div className={style.paymentAgreementState}>
              <div>{strings.generalStrings.currentState}</div>
              <div>{strings.PaymentAgreementStatusTranslation[ this.state.paymentAgreementStatus ]}</div>
            </div>
            <div className={style.chipCss}>
              { debtId ?
                <div className={style.chipWrapper}>
                  <Chip onClick={() => this.props.history.push( "/debt/" + debtId )}>
                    <Avatar style={{ backgroundColor: "#2196f3" }} icon="folder"/>
                    <span>{strings.generalStrings.watchProcess}</span>
                  </Chip>
                </div> :
                <div />}
              { debtId ?
                <div className={style.chipWrapper}>
                  <Chip onClick={() => this.toggleRemoveConfirm()}>
                    <Avatar style={{ backgroundColor: "#2196f3" }} icon="delete"/>
                    <span>{strings.generalStrings.deletePaymentAgreement}</span>
                  </Chip>
                </div> :
                <div />}
              { this.state.paymentAgreementStatus !== "Draft" ?
                <div className={style.chipWrapper}>
                  <Chip onClick={() => {
                    this.setState( {
                      isLoading: true,
                    }, () => this.downloadFile( parseInt( this.props.match.params.paymentAgreementId, 10 ) ) )
                  }}>
                    <Avatar style={{ backgroundColor: "#2196f3" }} icon="get_app"/>
                    <span>{strings.generalStrings.extractPaymentAgreement}</span>
                  </Chip>
                </div> :
                <div />}
            </div>
          </div>
        </div>
        {this.state.removeConfirmDialog ? this.renderConfirmationDialog( debtId ) : <div/> }
      </div>
    )
  }

  downloadFile = ( id: number ) => {
    const { type, idDebt } = this.props.paymentAgreementById
    const paymentAgreementFileName = type === "PaymentAgreement" ? "acordoPagamento_"
      : ( type === "DebtRecognitionByThirdParty" ? "reconhecimentoDívidaTerceiros_" : "reconhecimentoDívida_" )

    unparsedTokenCommand( this.props.auth.token, {
      command: "generatePaymentAgreementContract",
      args: {
        id,
      },
    } )
      .then( response => {
        if ( response.status !== 200 ) {
          throw new Error( "Error downloading file" )
        }

        const contentType = response.headers.get( "Content-type" )
        return response.blob()
          .then( blob => ( {
            contentType,
            blob,
          } ) )
      } ).then( file => download(
        file.blob,
        `${ paymentAgreementFileName + idDebt }.docx`,
        file.contentType
      ) ).then( () => {
        this.setState( { isLoading: false } )
      } ).catch( () => {
        this.setState( { isLoading: false } )
        toastr.error( strings.generalStrings.errorDownloading )
      } )
  }

  handlePaymentsChange = payments => {
    const totalChargedValue = payments => _.chain( payments )
      .map( payment => parseFloat( payment.value ) )
      .sum()
      .value()

    this.setState( {
      payments,
      totalChargedValue,
    } )
  }

  switchLoading = () => {
    this.setState( {
      isLoading: !this.state.isLoading,
    } )
  }

  renderLoadingDialog = () => {
    return <Dialog
      className={style.loadingDialog}
      active={this.state.isLoading}
      onEscKeyDown={this.switchLoading}
      onOverlayClick={this.switchLoading}
    ><div className={style.loader}/></Dialog>
  }


  render () {
    if ( !this.props.paymentAgreementById ) {
      return <div />
    }

    return (
      <div className={style.paymentBackground}>
        {this.renderHeader()}
        {this.renderClientIsland()}
        <Hidable title={strings.paymentAgreements.agreedPaymentAgreementTitle.toUpperCase()}>
          {this.renderPaymentAgreementIsland()}
        </Hidable>
        <div className={this.state.isEdit ? style.hiddenContent : style.showContent}>
          <Hidable title={"REGISTO DE PAGAMENTOS"}>
            <PaymentsTracking
              payments={this.state.payments}
              onChange={this.handlePaymentsChange.bind( this )}
              paymentAgreementId={parseInt( this.props.match.params.paymentAgreementId, 10 )}
            />
          </Hidable>
        </div>
        <Hidable title={"FATURAS"}>
          {this.renderInvoicesIsland()}
        </Hidable>
        <SaveButton
          onSave={this.updatePaymentAgreement}
          onCancel={this.resetPaymentAgreement}
          show={this.checkChanges()}
        />
        {this.renderLoadingDialog()}
      </div>
    )
  }
}


const mapStateToProps = ( store ) => {
  return {
    paymentAgreementById: store.paymentAgreementById,
    interestTypes: store.interestTypes,
    auth: store.auth,
  }
}

export default connect( mapStateToProps, {
  getPaymentAgreementById,
  updatePaymentAgreement,
  getAllInterestTypes,
} )( PaymentAgreement )



// WEBPACK FOOTER //
// ./src/views/PaymentAgreement/index.jsx